<template>
    <div class="my-tag flex flex--justify-between flex--align-center"
        :style="tagStyle"
        :disabled="disabled"
        @click="handleClick"
        @mouseover="hovered = true"
        @mouseout="hovered = false"
    >
        <div class="my-tag-text" :style="textStyle">{{ text }}</div>
        <v-icon v-if="removable" class="my-tag-icon" type="iconcancel-24px" @click.native.stop="handleRemove"></v-icon>
    </div>
</template>
<script>
export default {
    name: 'my-tag',
    props: {
        text: '',
        removable: {
            type: Boolean,
            default: false
        },
        disabled: {
            type: Boolean,
            default: false
        },
        background: {
            type: String,
            default: 'rgba(0, 0, 0, 0.12)'
        },
        backgroundDisabled: {
            type: String,
            default: 'rgba(0, 0, 0, 0.12)'
        },
        backgroundHover: {
            type: String,
            default: '#7C4DFF'
        },
        color: {
            type: String,
            default: '#7C4DFF'
        },
        colorDisabled: {
            type: String,
            default: 'rgba(0, 0, 0, 0.26)'
        },
        colorHover: {
            type: String,
            default: 'white'
        }
    },
    data() {
        return {
            hovered: false
        }
    },
    computed: {
        tagStyle() {
            if (this.disabled)
                return `background: ${this.backgroundDisabled}`;
            else if (this.hovered)
                return `background: ${this.backgroundHover}`;
            else
                return `background: ${this.background}`;
            
        },
        textStyle() {
            const styleArr = [];
            if (this.removable)
                styleArr.push('margin-right: 8px');
            else
                styleArr.push('margin-right: 16px');

            if (this.disabled)
                styleArr.push(`color: ${this.colorDisabled}`);
            else if (this.hovered)
                styleArr.push(`color: ${this.colorHover}`);
            else
                styleArr.push(`color: ${this.color}`);
            return styleArr.join(';');
        },
    },
    methods: {
        handleClick() {
            if (!this.disabled)
                this.$emit('click');
        },
        handleRemove() {
            if (!this.disabled)
                this.$emit('remove-tag')
        }
    }
}
</script>
<style lang="less">
    .my-tag {
        user-select: none;
        height: 24px;
        border-radius: 16px;
        margin-right: 4px;

        &[disabled]:hover {
            cursor: auto;
        }

        &:not([disabled]):hover {
            cursor: pointer;

            & .my-tag-icon {
                color: white;
            }
        }
    }

    .my-tag-text {
        font-weight: 500;
        font-size: 12px;
        line-height: 24px;
        margin-left: 16px;
    }
</style>